import React from "react";
import { Tab, Tabs } from "react-bootstrap";

interface TabOption {
  value: any;
  label: string;
  disabled?: boolean;
}

export interface TabInputProps {
  value: any[];
  onChange: (values: any[]) => void;
  options: TabOption[];
}

export default function TabInput({ value, onChange, options }: TabInputProps) {
  return (
    <Tabs
      id="controlled-tab-example"
      activeKey={value[0]}
      onSelect={(key) => onChange([key])}
    >
      {options.map((opt, idx) => (
        <Tab
          key={idx}
          disabled={opt.disabled}
          eventKey={opt.value}
          title={opt.label}
        />
      ))}
    </Tabs>
  );
}
